import { motion } from "framer-motion";

const ImprovementGraph = () => {
  const bars = [
    { height: "20%", delay: 1.0 },
    { height: "50%", delay: 1.3 },
    { height: "75%", delay: 1.6 },
  ];

  return (
    <div className="w-full h-[300px] bg-pink-50 rounded-2xl shadow-md relative overflow-hidden flex items-end justify-around px-6 pt-10 pb-8">
      {/* Axes */}
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        transition={{ duration: 0.7 }}
        className="absolute bottom-8 left-6 w-[2px] h-[80%] bg-gray-500 origin-bottom"
      />
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.7, delay: 0.3 }}
        className="absolute bottom-8 left-6 h-[2px] w-[90%] bg-gray-500 origin-left"
      />

      {/* Y Axis Label */}
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute left-0 top-[55%] text-gray-700 font-medium whitespace-nowrap rotate-[-90deg] origin-top-left"
      >
        Skin Improvement
      </motion.span>

      {/* Bars */}
      {bars.map((bar, index) => (
        <motion.div
          key={index}
          initial={{ height: 0 }}
          animate={{ height: bar.height }}
          transition={{ duration: 0.8, delay: bar.delay }}
          className={`w-16 rounded-t-xl ${
            index === 2 ? "bg-pink-400" : "bg-gray-400"
          }`}
        />
      ))}

      {/* X Labels */}
      {bars.map((_, index) => (
        <span
          key={index}
          className="absolute bottom-2 text-gray-700 text-xs font-medium whitespace-nowrap"
          style={{ left: `${10 + index * 30}%` }}
        >
          Ingredients Fit
        </span>
      ))}

      {/* Arrow at the end */}
    </div>
  );
};

export default ImprovementGraph;
